const initPaginate = () => {
  return {
    from: 1,
    to: 9,
    currentPage: 1,
    lastPage: 0,
    perPage: 10,
    total: 0,
  };
};

const state = {
  crewPagination: initPaginate(),
  searchCircularAttachmentPagination: initPaginate(),
};

const mutations = {
  set_crew_pagination(state, payload) {
    state.crewPagination = {
      from: payload.from,
      to: payload.to,
      currentPage: payload.current_page,
      lastPage: payload.last_page,
      perPage: payload.per_page,
      total: payload.total,
    };
  },

  set_circular_attachment_pagination(state, payload) {
    state.searchCircularAttachmentPagination = {
      from: payload.from,
      to: payload.to,
      currentPage: payload.current_page,
      lastPage: payload.last_page,
      perPage: payload.per_page,
      total: payload.total,
    };
  },

  reset_crew_pagination(state) {
    Object.assign(state.crewPagination, initPaginate());
  },

  reset_circular_attachment_pagination(state) {
    Object.assign(state.searchCircularAttachmentPagination, initPaginate());
  },


};

const actions = {
  resetCrewPagination({commit}) {
    commit('reset_crew_pagination');
  },

  resetCircularAttachmentPagination({commit}) {
    commit('reset_circular_attachment_pagination');
  },


};

const getters = {
  crewPagination: state => state.crewPagination,
  searchCircularAttachmentPagination: state => state.searchCircularAttachmentPagination,
};

/** export **/
export default {state, actions, mutations, getters};
